import React from 'react';
import { Typography } from 'Components/atoms';
import {
    AmplifierTrainingTemplateDefinition,
    AmplifierTrainingTemplateKey,
    getAmplifierTrainingTemplateByKey,
} from './amplifierTrainingTemplates';
import { ComplianceTrainingModuleOption } from './useComplianceTrainingModules';
import { ComplianceTrainingModulesTable } from './ComplianceTrainingModulesTable';

interface AmplifierTrainingConfigStepProps {
    templateKey: AmplifierTrainingTemplateKey;
    templates: AmplifierTrainingTemplateDefinition[];
    modules: ComplianceTrainingModuleOption[];
    modulesLoading: boolean;
    selectedSubjects: string[];
    onSelectedSubjectsChange: (subjects: string[]) => void;
    errors: string[];
}

export const AmplifierTrainingConfigStep: React.FC<AmplifierTrainingConfigStepProps> = ({
    templateKey,
    templates,
    modules,
    modulesLoading,
    selectedSubjects,
    onSelectedSubjectsChange,
    errors,
}) => {
    const template = getAmplifierTrainingTemplateByKey(templateKey, templates);
    const minModules = template?.minModules ?? 1;

    if (templateKey === 'scheduled') {
        return (
            <div className="action-block d-flex flex-column gap-2">
                <Typography variant="body2" color="text-high-emphasis">
                    {template?.title}
                </Typography>
                <Typography variant="body3" color="text-medium-emphasis">
                    This action assigns compliance training using your tenant schedule from Compliance Training
                    settings. No module selection is required here.
                </Typography>
            </div>
        );
    }

    if (modulesLoading) {
        return (
            <Typography variant="body3" color="text-medium-emphasis">
                Loading enabled training modules...
            </Typography>
        );
    }

    if (!modules.length) {
        return (
            <Typography variant="body3" color="vizualization-red-200">
                No enabled compliance training modules found. Enable modules on the Compliance Training page first.
            </Typography>
        );
    }

    if (templateKey === 'module') {
        return (
            <div className="action-block action-block--training-modules">
                <ComplianceTrainingModulesTable
                    modules={modules}
                    selectedSubjects={selectedSubjects}
                    onSelectedSubjectsChange={onSelectedSubjectsChange}
                    minModules={minModules}
                    showValidationError={errors.includes('module')}
                    selectionMode="single"
                />
            </div>
        );
    }

    return (
        <div className="action-block action-block--training-modules">
            <ComplianceTrainingModulesTable
                modules={modules}
                selectedSubjects={selectedSubjects}
                onSelectedSubjectsChange={onSelectedSubjectsChange}
                minModules={minModules}
                showValidationError={errors.includes('module')}
                selectionMode="multiple"
            />
        </div>
    );
};
